import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const lastUpdate: SxStyle = {
  fontWeight: (p) => p.typography.fontWeightMedium,
  color: (p) => p.palette.grey[600],
};

export const description: SxStyle = {
  color: (p) => p.palette.grey[500],
};

export const title: SxStyle = {
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[700],
};
export const card: SxStyle = { gap: '0 !important;' };

export const cardHeader: SxStyle = {};

export const cardContent: SxStyle = {
  padding: 1,
};

export const notFoundText: SxStyle = {
  fontWeight: 400,
  color: (p) => p.palette.grey[600],
};

export const header: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const alert: SxStyle = {
  marginY: (p) => p.spacing(0.5),
};
